import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import CustomStore from 'devextreme/data/custom_store';
import { NTECH_API } from './../app.api';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid } from './../app.config';
import { DxDataGridModule, DxDataGridComponent } from 'devextreme-angular';
import { EstadoService } from '../estado/estado.service'

@Component({
  selector: 'ntc-localidade',
  templateUrl: './localidade.component.html',
  styleUrls: ['./localidade.component.css']
})
export class LocalidadeComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  editOptionsGridLocalidade = null;
  colunasGridLocalidade = null;
  localidade = null;
  listaEstado = null;
  alturaGrid = null;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  constructor(
    @Inject(Http) http: Http,
    private estadoService: EstadoService
  ) {
    this.alturaGrid = calculaAlturaGrid();
    this.localidade = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/localidade/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/localidade/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/localidade/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/localidade/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });

    this.colunasGridLocalidade = [
      {
        dataField: 'Id',
        dataType: 'string',
        caption: 'ID',
        editorOptions: { disabled: true }
      },
      {
        dataField: 'NomeLocalidade',
        dataType: 'string',
        caption: 'Nome da Localidade',
        validationRules: [{
          type: 'required',
          message: 'Nome da Localidade é obrigatório.'
        }]
      },
      {
        dataField: 'SiglaLocalidade',
        dataType: 'string',
        caption: 'Sigla da Localidade',
        validationRules: [{
          type: 'required',
          message: 'Sigla da Localidade é obrigatória.'
        }]
      },
    ];

    this.editOptionsGridLocalidade = {
      mode: GridConfig.gridMode, // form
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      popup: {
        title: 'Estado',
        showTitle: true
      }
    };
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
    this.estadoService.getEstados().subscribe(estados => {
      this.listaEstado = estados;

      const selectEstado = {
        dataField: 'IdEstado',
        caption: 'Estado',
        lookup: {
            dataSource: this.listaEstado,
            displayExpr: 'NomeEstado',
            valueExpr: 'Id'
        },
        validationRules: [{
          type: 'required',
          message: 'Estado é obrigatório.'
        }]
      };

      this.colunasGridLocalidade.push(selectEstado);
    });
  }

}


// WEBPACK FOOTER //
// ./src/app/localidade/localidade.component.ts